<template>
  <div class="message-container text-center animated fadeInDown">
    <h2 class="message-title font-bold">{{$t('view.forgetPwdMessage.titleFirstPart')}} {{getNombre}}{{$t('view.forgetPwdMessage.titleSecondPart')}}</h2>
    <p class="message-instruction">
      {{$t('view.forgetPwdMessage.instructions')}}
    </p>
    <div class="sk-spinner sk-spinner-circle message-spinner">
        <div class="sk-circle1 sk-circle"></div>
        <div class="sk-circle2 sk-circle"></div>
        <div class="sk-circle3 sk-circle"></div>
        <div class="sk-circle4 sk-circle"></div>
        <div class="sk-circle5 sk-circle"></div>
        <div class="sk-circle6 sk-circle"></div>
        <div class="sk-circle7 sk-circle"></div>
        <div class="sk-circle8 sk-circle"></div>
        <div class="sk-circle9 sk-circle"></div>
        <div class="sk-circle10 sk-circle"></div>
        <div class="sk-circle11 sk-circle"></div>
        <div class="sk-circle12 sk-circle"></div>
    </div>
  </div>
</template>
<script>
const usuario={
  username:""
}
export default {
  name: "ForgetPwdMessage"
  , head: {
    title: function() {
      return {
        inner       : this.view.title
        , separator : '|'
        , complement: this.$t("view.home.system.initials")
      };
    }
  }
  , data() {
    let _locale = this.$store.language;
    return {
      usuario
      , nombre: undefined
      , locale: _locale
      , view:{
        title:"Restablecer contraseña"
        , errorMessage:{
          visible:false
          , text:""
        }
      }
    };
  }
  ,methods: {
    redirecToLogin(){
      setTimeout( () => this.$router.push({ name: 'SignIn'})
      , 5000);
    }
  }
  , computed:{
    userName(){
      return this.usuario.username;
    }
    , getNombre(){
      return this.nombre;
    }
  } 
  , created(){
    if(this.$route.params.username){
      const {username, nombre} = this.$route.params;
      console.log(this.$route.params)
      this.usuario.username = username;
      this.nombre = nombre;
      this.redirecToLogin();
    }else{
      this.$router.push("/401Unauthorized")
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.message-container{
  position:absolute;
  top: 30%; bottom:0; left:0; right:0;
  transform: translateY(-30%);
}
.message-title{
  margin-bottom: 15px;
  color:white;
  font-weight: bolder;
}
.message-instruction{
  margin-bottom: 15px;
  color:"#dadada";
}
</style>



// WEBPACK FOOTER //
// src/views/authentication/ForgetPwdMessage.vue